<template>
  <div
    class="gap-4 text-lg min-h-32 bg-white shadow p-3 rounded-lg border-2"
    :class="[
      {'border-primary': data?.is_available === undefined || data?.is_available === null},
      {'border-secondary': data?.is_available === true},
      {'border-red-500': data?.is_available === false}
    ]"
  >
    <div class="flex flex-row items-center justify-between gap-3 pb-2">
      <p>
        🚚<span class="text-primary font-semibold">
          Disponible en direct
        </span>
      </p>
      <base-spinner
        v-if="data.loading"
        size="small"
      />
      <icon
        v-else
        :name="data?.is_available ? 'mdi-check-bold' : 'mdi-close-thick'"
        :color="data?.is_available ? '#65efca' : 'red'"
        :size="25"
      />
    </div>
    <div
      v-if="!data.loading"
      class="text-sm space-y-2"
    >
      <p v-if="data.details?.laboratory?.name">
        {{ data.details.laboratory.name }}
      </p>
      <p v-if="data.details?.laboratory?.phone">
        <v-icon
          color="black"
          size="20"
        >
          mdi-phone
        </v-icon>
        {{ $filters.phoneFormat(data.details.laboratory.phone) }}
      </p>
      <p v-if="data.details?.laboratory?.email">
        <v-icon
          color="black"
          size="20"
        >
          mdi-email
        </v-icon>
        {{ data.details.laboratory.email }}
      </p>
      <p v-if="data.is_available === null">
        Dépositaire non joignable
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
import {
    AvailabilityState
} from "@/disruption-logistics/components/product-availability-card/ProductAvailabilityRateCard.vue";
import {DepositaryDetails} from "@/disruption-logistics/interfaces/availability-providers";
import BaseSpinner from "@/core/components/base/spinner/BaseSpinner.vue";

defineProps<{ data: AvailabilityState<DepositaryDetails> }>();
</script>

